import React from 'react';
import { Container, Typography, TextField, Button, Grid, Paper, Box } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ContactMailIcon from '@mui/icons-material/ContactMail';

const theme = createTheme({
  palette: {
    primary: {
      main: '#f44336',
    },
    secondary: {
      main: '#ffffff',
    },
  },
});

const ContactPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom>
          <ContactMailIcon sx={{ mr: 1 }} />
          Contato
        </Typography>
        <Paper elevation={3} sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Entre em contato conosco
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nome"
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                type="email"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Assunto"
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Mensagem"
                variant="outlined"
                multiline
                rows={4}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" color="primary" size="large">
                Enviar
              </Button>
            </Grid>
          </Grid>
        </Paper>
        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            Informações de Contato
          </Typography>
          <Typography variant="body1">
            <strong>Telefone:</strong> (85) 1234-5678
          </Typography>
          <Typography variant="body1">
            <strong>Email:</strong> contato@escolaexemplo.com.br
          </Typography>
          <Typography variant="body1">
            <strong>Endereço:</strong> Rua Exemplo, 123, Fortaleza, CE
          </Typography>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default ContactPage;
